<div class="update" *ngIf="showUpdate">
    {{ 'AppNewVersionTitle' | localize }}
    <button class="btn btn-primary btn-sm" (click)="clickUpdate()">{{ 'Update' | localize }}</button>
</div>